<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="6">
          <v-row dense align="center" class="pa-1">
            <v-text-field
              v-model="filter"
              clearable
              :label="$t('MaterialTemplate.priceTypes.filterHint')"
              @click:clear="filter = ''"
            ></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6">
          <v-row dense align="center" class="pa-1">
            <SearcherMaterialCategory v-model="categorySelected" />
          </v-row>
        </v-col>
        <v-col cols="12" sm="4">
          <v-row dense align="center" class="pa-1">
            <v-sheet class="transparent-background-color mt-4">
              <div
                class="caption grey--text input-chip-group-label"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ $t("Material.templates.usable") }}
              </div>
              <v-chip-group v-model="validFilter" column multiple>
                <v-chip
                  small
                  label
                  filter
                  class="me-1"
                  color="primary"
                  value="on"
                  >{{ $t("Material.templates.usable_on") }}
                </v-chip>
                <v-chip small label filter class="me-1" color="gray" value="off"
                  >{{ $t("Material.templates.usable_off") }}
                </v-chip>
              </v-chip-group>
            </v-sheet>
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="templateDetails"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        :footer-props="footerProps"
      >
        <template v-slot:header.valid>
          <v-checkbox
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="
              template_details.find((detail) => detail.valid != validAll)
                ? true
                : false
            "
            v-model="validAll"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("MaterialTemplate.valid_all") }}
              </span>
            </template>
          </v-checkbox>
        </template>

        <template v-slot:item.Description="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span>
                <v-icon v-bind="attrs" v-on="on" x-small>{{ item.hide_flg ? "fa-eye-slash" : "fa-eye" }}</v-icon>
                {{
                  $t(settings
                      ? settings.material_name_display_type == 1
                          ? "Material.materialName"
                          : settings.material_name_display_type == 4
                              ? "Material.nameWithCode"
                          : "Material.materialNameWithCode"
                      : "Material.materialName", [item.material_code, item.material_name])
                }}
              </span>
              <span class="caption secondary--text">
                {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
                <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                  {{ item.standard_name.slice(0, 12) + "......" }}
                </span>
                <span v-else>
                  {{ item.standard_name }}
                </span>
              </span>
            </template>
            <span>
              {{
                item.hide_flg
                  ? $t("Material.hideFlgs.on")
                  : $t("Material.hideFlgs.off")
              }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:item.valid="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-checkbox
              color="primary"
              v-model="item.valid"
              :true-value="1"
              :false-value="0"
            >
              <template v-slot:label>
                <span class="caption ms-n2">
                  {{
                    $t(
                      item.valid
                        ? "Material.templates.usable_on"
                        : "Material.templates.usable_off"
                    )
                  }}
                </span>
              </template>
            </v-checkbox>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="accent"
          @click="
            $emit(
              'confirm',
              changedDetails.filter(
                (d) =>
                  template_details.find((detail) => detail.id == d.id) &&
                  (d.status || d.status != d.valid)
              )
            );
            dialog = false;
          "
        >
          {{ $t("CRUD.confirm") }}
          <!-- {{ $t("CRUD.confirmWithChooseCount", [template.material_count
                ? template.material_count -
                  changedDetails.filter((s) => s.status).length +
                  changedDetails.filter((s) => s.valid).length
                : 0]) }} -->
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
// import MaterialTemplates from "@/api/material_templates";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";
import PresaleTemplates from "@/api/presale_templates";

export default {
  name: "SelectTemplateMaterials",

  props: {
    value: Boolean,
    changed: Array,
  },

  components: {
    SearcherMaterialCategory,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("MaterialTemplate.Fields.material_category"),
          align: "start",
          sortable: true,
          filterable: true,
          value: "category_name",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.material"),
          align: "start",
          sortable: true,
          filterable: true,
          value: "Description",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.valid"),
          align: "start",
          sortable: false,
          filterable: false,
          value: "valid",
        },
      ];
    },
    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },
    templateDetails() {
      return this.template_details.filter(
        (item) =>
          ((item.valid
            ? this.validFilter.find((v) => v == "on")
            : this.validFilter.find((v) => v == "off")) ||
            !this.validFilter.length) &&
          (!this.filter || item.Description.indexOf(this.filter) >= 0) &&
          ((this.categorySelected &&
            item.category_name.indexOf(this.categorySelected.name) > -1) ||
            !this.categorySelected)
      );
    },
    choosenCount() {
      return this.changedDetails.filter((d) => d.valid == 1).length;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    itemsPerPageOptions: 10,
    filter: "",
    categorySelected: null,
    validFilter: ["on", "off"],
    template: {},
    template_details: [],
    fetchTimestamp: 0,
    validAll: 0,
    changedDetails: [],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          // 每次打开对话框重置查询条件和changedDetails
          this.filter = "";
          if (this.changed)
            this.changedDetails = JSON.parse(JSON.stringify(this.changed));
          this.getTemplateMaterialsFromAPI();
        }
      },
    },
    changed: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.changed)
          this.changedDetails = JSON.parse(JSON.stringify(this.changed));
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
    validAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            var d = this.templateDetails.find((d) => d.id == detail.id);
            if (d) detail.valid = this.validAll ? 1 : 0;
            return detail;
          }.bind(this)
        );
      },
    },
    template_details: {
      deep: true,
      handler() {
        this.changedDetails.forEach((s) => {
          var detail = this.template_details.find(
            (detail) => detail.id == s.id
          );
          if (detail) {
            s.valid = detail.valid;
          }
        }); // 原先已经改变过的，更新valid值
        this.template_details.forEach((detail) => {
          if (detail.valid != detail.status) {
            var s = this.changedDetails.find((s) => detail.id == s.id);
            if (!s) {
              this.changedDetails.push(detail);
            }
          }
        }); // 新改变的，添加到changedDetails数组中
      },
    },
  },

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    getTemplateMaterialsFromAPI() {
      if (new Date().getTime() - this.fetchTimestamp < 30 * 60 * 1000) return; // 半小时内不重新刷新以提高效率
      this.template = {};
      this.template_details = [];
      this.validAll = 0;
      PresaleTemplates.fetchPresales(this.$route.params.id, {
        readonly: 0,
        status: [0, 1],
        limit: this.$consts.limitAll,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.fetchTimestamp = new Date().getTime();
            this.template = response.data.template;
            this.template_details = response.data.template_details.map(
              (item) => {
                var select = this.changedDetails.find((s) => s.id == item.id);
                item.supply_price = Number(item.supply_price);
                item.cost_price_percent = Number(item.cost_price_percent);
                item.multiple = Number(item.multiple);
                item.min_num = Number(item.min_num);
                item.valid = select ? select.valid : item.status ? 1 : 0;
                item.Description = i18n.t(
                  this.settings
                    ? this.settings.material_name_display_type == 4
                      ? "Material.nameWithCodeAndStandard"
                      : this.settings.material_name_display_type == 3
                      ? "Material.materialNameWithCodeAndStandard"
                      : this.settings.material_name_display_type == 2
                      ? "Material.materialNameWithCode"
                      : "Material.materialName"
                    : "Material.materialName",
                  [item.material_code, item.material_name, item.standard_name]
                );
                return item;
              }
            );
            if (!this.template_details.find((d) => !d.valid)) this.validAll = 1; // 如果当前页没有无效的，validAll值设为全有效
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
  },
};
</script>